import { generateClient, post, put } from "aws-amplify/api";
import awsconfig from "../../aws-exports";
import { getUrl, uploadData } from "aws-amplify/storage";

const client = generateClient();

export async function requestListConsultantTutoringProgram(dispatch, payload) {
  try {
    const { limit = 10, page, consultantID, nextToken = null } = payload;

    dispatch({
      type: "REQUEST_LIST_TUTORING_PROGRAM",
      payload: { page },
    });

    const params = {
      limit,
      nextToken,
      consultantID,
      sortDirection: "DESC",
    };

    const res = await client.graphql({
      query: tutoringsByConsultantCreatedAt,
      variables: params,
    });

    dispatch({
      type: "REQUEST_LIST_TUTORING_PROGRAM",
      payload: { res, page },
    });

    let { items, nextToken: token } = res.data.tutoringsByConsultantCreatedAt;

    let fetchedUrl = {};

    items = await Promise.all(
      items.map(async (item) => {
        let updatedItem = item;
        if (item.image?.key) {
          const { identityId, key } = item.image;
          try {
            let signedUrl = "";
            if (fetchedUrl[key]) {
              signedUrl = fetchedUrl[key];
            } else {
              const urlResult = await getUrl({
                path: `protected/${identityId}/${key}`,
                options: {
                  useAccelerateEndpoint: true,
                },
              });
              signedUrl = urlResult.url.href;
              fetchedUrl[key] = signedUrl;
            }
            if (signedUrl) {
              updatedItem = {
                ...updatedItem,
                imageUrl: signedUrl,
              };
            }
          } catch (error) {}
        }
        return updatedItem;
      })
    );

    const nextPage = page + 1;

    dispatch({
      type: "LIST_TUTORING_PROGRAM_SUCCESS",
      payload: { items, nextToken: token, nextPage },
    });
  } catch (error) {
    dispatch({ type: "LIST_TUTORING_PROGRAM_ERROR", error });
  }
}

export async function requestCreateConsultantTutoringProgram(
  dispatch,
  payload
) {
  try {
    dispatch({
      type: "REQUEST_CREATE_TUTORING_PROGRAM",
      payload: { request: null },
    });
    const { input } = payload;

    if (input.image) {
      const key = `tutoring/${input.image.name}`;

      const upload = uploadData({
        path: ({ identityId }) => `protected/${identityId}/${key}`,
        data: input.image,
      });

      const result = await upload.result;

      if (result.path) {
        input.image = {
          key,
          bucket: awsconfig.aws_user_files_s3_bucket,
          region: awsconfig.aws_user_files_s3_bucket_region,
        };
      }
    }

    const request = post({
      apiName: "consultant",
      path: "/tutoring",
      options: {
        body: input,
      },
    });
    dispatch({
      type: "REQUEST_CREATE_TUTORING_PROGRAM",
      payload: { request },
    });

    const { body } = await request.response;
    const res = await body.json();

    dispatch({
      type: "CREATE_TUTORING_PROGRAM_SUCCESS",
      payload: { newTutoring: res.data },
    });
  } catch (error) {
    dispatch({ type: "CREATE_TUTORING_PROGRAM_ERROR", error });
  }
}

export async function requestGetConsultantTutoringProgram(dispatch, payload) {
  try {
    const { id } = payload;

    dispatch({
      type: "REQUEST_GET_TUTORING_PROGRAM",
    });

    const params = {
      id,
    };

    const res = await client.graphql({
      query: getTutoringProgram,
      variables: params,
    });

    let result = res.data.getTutoringProgram;

    let fetchedUrl = {};
    let updatedItem = result;

    if (result?.image?.key) {
      const { identityId, key } = result.image;
      try {
        let signedUrl = "";
        if (fetchedUrl[key]) {
          signedUrl = fetchedUrl[key];
        } else {
          const urlResult = await getUrl({
            path: `protected/${identityId}/${key}`,
            options: {
              useAccelerateEndpoint: true,
            },
          });
          signedUrl = urlResult.url.href;
          fetchedUrl[key] = signedUrl;
        }
        if (signedUrl) {
          updatedItem = {
            ...updatedItem,
            imageUrl: signedUrl,
          };
        }
      } catch (error) {}
    }

    dispatch({
      type: "GET_TUTORING_PROGRAM_SUCCESS",
      payload: { item: updatedItem },
    });
  } catch (error) {
    dispatch({ type: "GET_TUTORING_PROGRAM_ERROR", error });
  }
}

export async function requestUpdateConsultantTutoringProgram(
  dispatch,
  payload
) {
  try {
    dispatch({
      type: "REQUEST_UPDATE_TUTORING_PROGRAM",
      payload: { request: null },
    });
    const { input } = payload;

    if (input.image && input.image !== null && !input.image?.key) {
      const key = `tutoring/${input.image.name}`;

      const upload = uploadData({
        path: ({ identityId }) => `protected/${identityId}/${key}`,
        data: input.image,
      });

      const result = await upload.result;

      if (result.path) {
        input.image = {
          key,
          bucket: awsconfig.aws_user_files_s3_bucket,
          region: awsconfig.aws_user_files_s3_bucket_region,
        };
      }
    }

    const request = put({
      apiName: "consultant",
      path: "/tutoring",
      options: {
        body: input,
      },
    });
    dispatch({
      type: "REQUEST_UPDATE_TUTORING_PROGRAM",
      payload: { request },
    });

    const { body } = await request.response;
    const res = await body.json();

    dispatch({
      type: "UPDATE_TUTORING_PROGRAM_SUCCESS",
      payload: { updateTutoring: res.data },
    });
  } catch (error) {
    dispatch({ type: "UPDATE_TUTORING_PROGRAM_ERROR", error });
  }
}

export async function requestListTutoringProgram(dispatch, payload) {
  try {
    const { limit = 10, page, nextToken = null } = payload;

    dispatch({
      type: "REQUEST_LIST_TUTORING_PROGRAM",
      payload: { page },
    });

    const params = {
      type: "PRIVATE",
      limit,
      nextToken,
      sortDirection: "DESC",
      filter: {
        available: {
          eq: true,
        },
      },
    };

    const res = await client.graphql({
      query: tutoringsByTypeCreatedAt,
      variables: params,
    });

    dispatch({
      type: "REQUEST_LIST_TUTORING_PROGRAM",
      payload: { res, page },
    });

    let { items, nextToken: token } = res.data.tutoringsByTypeCreatedAt;

    let fetchedUrl = {};

    items = await Promise.all(
      items.map(async (item) => {
        let updatedItem = item;
        if (item.image?.key) {
          const { identityId, key } = item.image;
          try {
            let signedUrl = "";
            if (fetchedUrl[key]) {
              signedUrl = fetchedUrl[key];
            } else {
              const urlResult = await getUrl({
                path: `protected/${identityId}/${key}`,
                options: {
                  useAccelerateEndpoint: true,
                },
              });
              signedUrl = urlResult.url.href;
              fetchedUrl[key] = signedUrl;
            }
            if (signedUrl) {
              updatedItem = {
                ...updatedItem,
                imageUrl: signedUrl,
              };
            }
          } catch (error) {}
        }

        if (item.consultant?.user?.image?.key) {
          const { identityId, key } = item.consultant.user.image;
          try {
            const urlResult = await getUrl({
              path: `protected/${identityId}/${key}`,
              options: {
                useAccelerateEndpoint: true,
              },
            });
            const signedUrl = urlResult.url.href;
            if (signedUrl) {
              updatedItem = {
                ...updatedItem,
                consultant: {
                  ...updatedItem.consultant,
                  user: {
                    ...updatedItem.consultant.user,
                    imageUrl: signedUrl,
                  },
                },
              };
            }
          } catch (error) {}
        }

        return updatedItem;
      })
    );

    const nextPage = page + 1;

    dispatch({
      type: "LIST_TUTORING_PROGRAM_SUCCESS",
      payload: { items, nextToken: token, nextPage },
    });
  } catch (error) {
    dispatch({ type: "LIST_TUTORING_PROGRAM_ERROR", error });
  }
}

export async function requestListTutoringProgramSchedule(dispatch, payload) {
  try {
    const {
      limit = 10,
      page,
      startOfDay,
      endOfDay,
      nextToken = null,
    } = payload;

    dispatch({
      type: "REQUEST_LIST_TUTORING_PROGRAM",
      payload: { page },
    });

    const params = {
      status: "AVAILABLE",
      limit,
      nextToken,
      scheduledAt: {
        between: [startOfDay, endOfDay],
      },
      sortDirection: "DESC",
    };

    const res = await client.graphql({
      query: schedulesByStatusScheduledAt,
      variables: params,
    });

    dispatch({
      type: "REQUEST_LIST_TUTORING_PROGRAM",
      payload: { res, page },
    });

    let { items, nextToken: token } = res.data.schedulesByStatusScheduledAt;

    let fetchedUrl = {};

    items = await Promise.all(
      items.map(async (item) => {
        let updatedItem = item;
        if (item.program.image?.key) {
          const { identityId, key } = item.program.image;
          try {
            let signedUrl = "";
            if (fetchedUrl[key]) {
              signedUrl = fetchedUrl[key];
            } else {
              const urlResult = await getUrl({
                path: `protected/${identityId}/${key}`,
                options: {
                  useAccelerateEndpoint: true,
                },
              });
              signedUrl = urlResult.url.href;
              fetchedUrl[key] = signedUrl;
            }
            if (signedUrl) {
              updatedItem = {
                ...updatedItem,
                imageUrl: signedUrl,
              };
            }
          } catch (error) {}
        }

        return updatedItem;
      })
    );

    const nextPage = page + 1;

    dispatch({
      type: "LIST_TUTORING_PROGRAM_SUCCESS",
      payload: { items, nextToken: token, nextPage },
    });
  } catch (error) {
    dispatch({ type: "LIST_TUTORING_PROGRAM_ERROR", error });
  }
}

export async function requestListTutoringSchedule(dispatch, payload) {
  try {
    const { programID } = payload;

    dispatch({
      type: "REQUEST_LIST_TUTORING_SCHEDULE",
    });

    const params = {
      programID,
      scheduledAt: { gt: new Date().toISOString() },
      sortDirection: "DESC",
    };

    const res = await client.graphql({
      query: schedulesByProgramScheduledAt,
      variables: params,
    });

    const { items } = res.data.schedulesByProgramScheduledAt;

    if (!items) {
      throw new Error("Schedule not found.");
    }

    dispatch({
      type: "LIST_TUTORING_SCHEDULE_SUCCESS",
      payload: { items },
    });
  } catch (error) {
    dispatch({ type: "LIST_TUTORING_SCHEDULE_ERROR", error });
  }
}

export async function requestGetTutoringProgram(dispatch, payload) {
  try {
    const { id } = payload;

    dispatch({
      type: "REQUEST_GET_TUTORING_PROGRAM",
    });

    const params = {
      id,
    };

    const res = await client.graphql({
      query: getTutoringProgram,
      variables: params,
    });

    let result = res.data.getTutoringProgram;

    let fetchedUrl = {};
    let updatedItem = result;

    if (result?.image?.key) {
      const { identityId, key } = result.image;
      try {
        let signedUrl = "";
        if (fetchedUrl[key]) {
          signedUrl = fetchedUrl[key];
        } else {
          const urlResult = await getUrl({
            path: `protected/${identityId}/${key}`,
            options: {
              useAccelerateEndpoint: true,
            },
          });
          signedUrl = urlResult.url.href;
          fetchedUrl[key] = signedUrl;
        }
        if (signedUrl) {
          updatedItem = {
            ...updatedItem,
            imageUrl: signedUrl,
          };
        }
      } catch (error) {}
    }

    if (result?.consultant?.user?.image?.key) {
      const { identityId, key } = result.consultant.user.image;
      try {
        const urlResult = await getUrl({
          path: `protected/${identityId}/${key}`,
          options: {
            useAccelerateEndpoint: true,
          },
        });
        const signedUrl = urlResult.url.href;
        if (signedUrl) {
          updatedItem = {
            ...updatedItem,
            consultant: {
              ...updatedItem.consultant,
              user: {
                ...updatedItem.consultant.user,
                imageUrl: signedUrl,
              },
            },
          };
        }
      } catch (error) {}
    }

    dispatch({
      type: "GET_TUTORING_PROGRAM_SUCCESS",
      payload: { item: updatedItem },
    });
  } catch (error) {
    dispatch({ type: "GET_TUTORING_PROGRAM_ERROR", error });
  }
}

export async function resetCreateTutoringProgram(dispatch) {
  dispatch({ type: "RESET_TUTORING_PROGRAM" });
}

const tutoringsByConsultantCreatedAt = /* GraphQL */ `
  query TutoringsByConsultantCreatedAt(
    $consultantID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTutoringProgramFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tutoringsByConsultantCreatedAt(
      consultantID: $consultantID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        available
        type
        category {
          id
          name
        }
        title
        body
        consultant {
          id
          user {
            id
            name
          }
          lastSeen
          totalRating
          rating
          totalMonthlyConsultation
          totalConsultation
          averageResponse
        }
        image {
          bucket
          region
          key
          identityId
        }
        callEnabled
        zoomEnabled
        price
        duration
        supportingFiles {
          name
          mediaType
          required
        }
        schedules {
          items {
            id
            status
            scheduledAt
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const getTutoringProgram = /* GraphQL */ `
  query GetTutoringProgram($id: ID!) {
    getTutoringProgram(id: $id) {
      id
      available
      type
      category {
        id
        name
      }
      title
      body
      consultant {
        id
        user {
          id
          name
          image {
            bucket
            region
            key
            identityId
          }
        }
        lastSeen
        totalRating
        rating
        totalMonthlyConsultation
        totalConsultation
        averageResponse
        createdAt
        updatedAt
      }
      image {
        bucket
        region
        key
        identityId
      }
      callEnabled
      zoomEnabled
      price
      duration
      requirements {
        name
        description
      }
      supportingFiles {
        name
        mediaType
        required
      }
      schedules {
        items {
          id
          programID
          consultationID
          status
          scheduledAt
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;

const tutoringsByTypeCreatedAt = /* GraphQL */ `
  query TutoringsByTypeCreatedAt(
    $type: TutoringProgramType
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTutoringProgramFilterInput
    $limit: Int
    $nextToken: String
  ) {
    tutoringsByTypeCreatedAt(
      type: $type
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        available
        type
        category {
          id
          name
        }
        title
        body
        consultant {
          id
          active
          startTimes
          endTimes
          activeDays
          user {
            id
            name
            image {
              bucket
              region
              key
              identityId
            }
          }
          city
          experience
          workStartYear
          consultationPrice
          callPrice
          audioPrice
          zoomPrice
          lastSeen
          totalRating
          rating
          totalMonthlyConsultation
          totalConsultation
          averageResponse
        }
        image {
          bucket
          region
          key
          identityId
        }
        callEnabled
        zoomEnabled
        price
        duration
        supportingFiles {
          name
          mediaType
          required
        }
        schedules {
          nextToken
          items {
            id
            status
            scheduledAt
          }
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

const schedulesByProgramScheduledAt = /* GraphQL */ `
  query SchedulesByProgramScheduledAt(
    $programID: ID
    $scheduledAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelScheduledConsultationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    schedulesByProgramScheduledAt(
      programID: $programID
      scheduledAt: $scheduledAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        scheduledAt
      }
      nextToken
    }
  }
`;

const schedulesByStatusScheduledAt = /* GraphQL */ `
  query SchedulesByStatusScheduledAt(
    $status: ScheduledConsultationStatus
    $scheduledAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelScheduledConsultationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    schedulesByStatusScheduledAt(
      status: $status
      scheduledAt: $scheduledAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        programID
        program {
          id
          available
          type
          category {
            id
            name
            createdAt
            updatedAt
          }
          title
          body
          consultant {
            id
            user {
              id
              name
            }
          }
          image {
            bucket
            region
            key
            identityId
          }
          callEnabled
          zoomEnabled
          price
          duration
          createdAt
          updatedAt
        }
        status
        scheduledAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
